<template>
  <div class="journey-card-contents">
    <div class="overflow-hidden">
      <div class="details-grid">
        <div class="d-contents" v-for="(leg, index) in props.journeyLegs" :key="index">
          <journey-leg v-if="leg.type === 'leg'" :leg="leg"></journey-leg>
          <journey-transfer
            v-else-if="leg.type === 'transfer'"
            :previousLeg="props.journeyLegs[index - 1]"
            :transfer="leg"
            :nextLeg="props.journeyLegs[index + 1]"
          ></journey-transfer>
        </div>
        <destination-punctuality
          v-if="lastLeg.arrivalDelayPrediction"
          :prediction="lastLeg.arrivalDelayPrediction"
          :arrivalTime="lastLeg.arrival"
        ></destination-punctuality>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type Leg, type Transfer } from '~/types/fptfTypes'
import JourneyLeg from '~/components/JourneyDisplay/JourneyLeg.vue'
import JourneyTransfer from '~/components/JourneyDisplay/JourneyTransfer.vue'
import DestinationPunctuality from './DestinationPunctuality.vue'

const props = defineProps<{
  journeyLegs: (Leg | Transfer)[]
}>()

const lastLeg = computed(() => {
  return props.journeyLegs.filter((leg) => leg.type === 'leg').slice(-1)[0] as Leg
})
</script>

<style lang="scss">
.journey-card-contents {
  overflow: auto;
  cursor: auto;
}

.details-grid {
  display: inline-grid;
  grid-template-columns: 1fr;
  width: 100%;
  max-width: 100%;
}

@include media-breakpoint-up(sm) {
  .details-grid {
    margin: 10px;
    width: calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
}
</style>
